const apiUrls = require('../../constants/apiUrls');

const orderServices = {
    key: 'orderServices',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_SERVICES_URL}?workOrderNumber[]=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default orderServices;


// WEBPACK FOOTER //
// ./src/store/order-details-config/orderServices.js